// import React from 'react'

// const TrackingOrders = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default TrackingOrders
//imports
import React, { useEffect, useState } from "react";
import {
  Box,
  AppBar,
  Grid,
  Stack,
  Autocomplete,
  TextField,
  CircularProgress,
  Breadcrumbs,
  Link,
  Button,
  Chip,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { externalgetApi } from "../../services/external/externalApis";
import { ORDER_API_03 } from "../../api/ApiModel";
import {
  CON_STATUS_ACTIVE,
  CON_STATUS_DELETED,
  CON_STATUS_PENDING,
  CON_STATUS_RETURN,
} from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import Navbar from "../../components/common/Navbar";
import ViewData from "../../components/grids/ViewDatagrid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { Orderlistdata, Trackorderlistdata } from "../../assets/Griddata";
import { useStyles } from "../../assets/styles/Theme";
import { currencyFormatLKR } from "../../utils/common/CurrencyFormat";
import PhonelinkEraseIcon from "@mui/icons-material/PhonelinkErase";
import CurrencyExchangeRoundedIcon from "@mui/icons-material/CurrencyExchangeRounded";
function TrackingOrders() {
  //hooks
  const [orderData, setOrderData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState({
    ORDERSTATUSCODE: CON_STATUS_ACTIVE,
    ORDERSTATUSNAME: "Active",
  });

  const navigate = useNavigate();
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  const orderStatuses = [
    { ORDERSTATUSCODE: CON_STATUS_ACTIVE, ORDERSTATUSNAME: "Active" },
    { ORDERSTATUSCODE: CON_STATUS_PENDING, ORDERSTATUSNAME: "Pending" },
    { ORDERSTATUSCODE: CON_STATUS_RETURN, ORDERSTATUSNAME: "Return" },
  ];

  const theme = useTheme();
  const styles = useStyles(theme);

  useEffect(() => {
    if (selectedStatus.ORDERSTATUSCODE) {
      fetchOrderData(selectedStatus.ORDERSTATUSCODE);
    }
  }, [selectedStatus]);

  const fetchOrderData = async (statusCode) => {
    setLoading(true);
    const params = {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      FROMDATE: "1/1/2023",
      TODATE: new Date(),
      STS:"A"
    };
    try {
      const response = await externalgetApi(ORDER_API_03, "GET", params);
      setOrderData(response || []);
    } catch (err) {
      console.error("Failed to fetch order data:", err);
    } finally {
      setLoading(false);
    }
  };

  const mapResultToRows = (result) => {
    return result.map((item, index) => ({
      id: index + 1,
      INVNO: item.INVNO,
      ORDERCODE: item.ORDERCODE,
      ORDERENDATE: item.ORDERENDATE,
     
      AMOUNT: currencyFormatLKR(item.AMOUNT, "LKR", false),
    }));
  };
//handlers
  const handleStatusChange = (status) => {
    setSelectedStatus(status);
  };

  const handleItemClick = (ORDERCODE, actionText) => {
    const selectedItem = orderData.find((item) => item.ORDERCODE === ORDERCODE);
    if (selectedItem) {
      navigate(`/Viewtrackinglist`, {
        state: { selectedItem, actionText, ORDERCODE },
      });
    }
  };


  const menuItems = [
    {
      text: "Tracking",
      icon: <PhonelinkEraseIcon />,
      onClick: (ORDERCODE) => handleItemClick(ORDERCODE, "Tracking"),
    },
   
  ];

  return (
    <>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                sx={styles.AI_breadcrumbs2}
              >
                <Link underline="hover">Home</Link>
                <Link underline="hover">Order</Link>
                <Link underline="hover">Order List</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item p={2}>
              <Stack
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
                sx={styles.AI_fixedStack1}
              >
                {/* <Autocomplete
                  value={selectedStatus}
                  onChange={(event, newValue) => handleStatusChange(newValue)}
                  options={orderStatuses}
                  getOptionLabel={(option) => option.ORDERSTATUSNAME || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.ORDERSTATUSCODE === value?.ORDERSTATUSCODE
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Order Status"
                      variant="outlined"
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "43px",
                          width: "300px",
                        },
                      }}
                    />
                  )}
                  ListboxProps={{
                    style: {
                      maxHeight: 180,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                /> */}
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      {loading ? (
        <CircularProgress />
      ) : (
        <ViewData
          columns={Trackorderlistdata.columns}
          rows={mapResultToRows(orderData)}
          menuItems={menuItems}
          tabletitle={Trackorderlistdata.name}
          gridid="ORDERCODE"
        />
      )}
    </>
  );
}

export default TrackingOrders;
